import { Typography } from "@trustpilot/constellation-components";
import { Text } from "ilenia";
import React from "react";

import styles from "../../styles/sideNav.module.scss";

export const Badge = () => {
  return (
    <div className={styles.sidebarBadge}>
      <Typography variant={"body-xs"}>
        <Text id="Sidebar.badges.new" />
      </Typography>
    </div>
  );
};
